import { useQuery } from '@tanstack/react-query';
import {
  showHubspotCompanyOverviewContract,
  type ShowHubspotCompanyOverviewResponse
} from '@bliks-io/contracts';
import { apiClient } from '@/api/client';
import { hubspotCompanyKeys } from '@/api/query-keys';

/**
 * Super-admin preview of a HubSpot company (basics + licenses + status) for the
 * tenant create/edit dialog. Disabled until a plausible id is entered; 404s
 * (unknown id) are not retried.
 */
export function useHubspotCompanyOverview(companyId: string) {
  const id = companyId.trim();
  return useQuery({
    queryKey: hubspotCompanyKeys.detail(id),
    queryFn: async ({ signal }): Promise<ShowHubspotCompanyOverviewResponse> => {
      const { data } = await apiClient.get<ShowHubspotCompanyOverviewResponse>(
        showHubspotCompanyOverviewContract.path.replace(':companyId', id),
        { signal }
      );
      return data;
    },
    enabled: id.length > 3,
    retry: false,
    staleTime: 60_000
  });
}
